<app-loading-dots *ngIf="isFetching"></app-loading-dots>

<app-third-party-loader
    *ngFor="let script of extraScripts"
    [url]="script"
    [scriptOptions]="{
        async: true,
        position: 'beforeBodyEnd',
        attributes: { type: 'module', crossorigin: 'anonymous' }
    }"
    [consent]="consent"
></app-third-party-loader>

<iframe class="iframe"
        #iframeEl
        [id]="id"
        [title]="title + '-' + id"
        [src]="src | safe: 'resourceUrl'"
        [ngStyle]="iFrameStyle | parseStyle"
        [attr.data-hj-allow-iframe]="true"
></iframe>
